import BaseDB from 'libs/DB/BaseDB'

const icsDB = new BaseDB('icsSubscriptionDB', {
  version: 1,
  key: 'subscriptionId',
  expireDuration: 30 * 24 * 60 * 60 * 1000, // 30일
  skipPreload: false,
})

export default icsDB
